export const manifest = {
  screens: {
    scr_qpvyw7: { name: "Court Rush landing", route: "/court-rush", state: {"screen":"landing"}, position: {"x":160,"y":220} },
    scr_i5yegm: { name: "Start Misl", route: "/court-rush", state: {"screen":"start"}, position: {"x":160,"y":2200} },
    scr_oc9wh9: { name: "Google login", route: "/court-rush", state: {"screen":"google"}, position: {"x":1560,"y":220} },
    scr_xv2syz: { name: "WhatsApp opt-in", route: "/court-rush", state: {"screen":"whatsapp"}, position: {"x":2960,"y":220} },
    scr_4zgb5g: { name: "Share invite", route: "/court-rush", state: {"screen":"share"}, position: {"x":1560,"y":2200} },
    scr_hf9e59: { name: "Join Misl", route: "/court-rush", state: {"screen":"join"}, position: {"x":160,"y":4180} },
    scr_vtw554: { name: "Live Rush dashboard", route: "/court-rush", state: {"screen":"dashboard"}, position: {"x":160,"y":6160} },
    scr_52dh9g: { name: "Court Packet", route: "/court-rush", state: {"screen":"packet"}, position: {"x":1560,"y":6160} },
    scr_u82t8o: { name: "Two-card reveal", route: "/court-rush", state: {"screen":"reveal"}, position: {"x":2960,"y":6160} },
    scr_w84ht7: { name: "Card contribution", route: "/court-rush", state: {"screen":"contribute"}, position: {"x":4360,"y":6160} },
    scr_afn9mq: { name: "Memory awakened", route: "/court-rush", state: {"screen":"awakened"}, position: {"x":5760,"y":6160} },
    scr_2nbi2f: { name: "Court Gates", route: "/court-rush", state: {"screen":"gates"}, position: {"x":7160,"y":6160} },
    scr_9ag3z6: { name: "Court Challenge", route: "/court-rush", state: {"screen":"challenge"}, position: {"x":8560,"y":6160} },
    scr_hd3w67: { name: "Live leaderboard", route: "/court-rush", state: {"screen":"leaderboard"}, position: {"x":9960,"y":6160} },
    scr_gyrws6: { name: "Rush result", route: "/court-rush", state: {"screen":"result"}, position: {"x":160,"y":8140} },
    scr_n5uifq: { name: "Free seat claim", route: "/court-rush", state: {"screen":"seats"}, position: {"x":1560,"y":4180} },
    scr_j0s6va: { name: "Attendance confirmation", route: "/court-rush", state: {"screen":"attendance"}, position: {"x":2960,"y":4180} },
    scr_uo95yt: { name: "Victory share", route: "/court-rush", state: {"screen":"victory"}, position: {"x":1560,"y":8140} },
    scr_qqjo3p: { name: "Court Rush admin", route: "/court-rush", state: {"screen":"admin"}, position: {"x":160,"y":10120} },
  },
  sections: {
    sec_kepf1m: { name: "Onboarding & Auth", x: 0, y: 0, width: 4320, height: 1180 },
    sec_8ey71m: { name: "Game Creation", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_phyx4a: { name: "Game Participation", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_wfdsi5: { name: "Active Gameplay", x: 0, y: 5940, width: 11320, height: 1180 },
    sec_h3nwe0: { name: "Results & Share", x: 0, y: 7920, width: 2920, height: 1180 },
    sec_oo5hxd: { name: "Admin", x: 0, y: 9900, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_kepf1m", children: [
      { kind: "screen", id: "scr_qpvyw7" },
      { kind: "screen", id: "scr_oc9wh9" },
      { kind: "screen", id: "scr_xv2syz" },
    ] },
    { kind: "section", id: "sec_8ey71m", children: [
      { kind: "screen", id: "scr_i5yegm" },
      { kind: "screen", id: "scr_4zgb5g" },
    ] },
    { kind: "section", id: "sec_phyx4a", children: [
      { kind: "screen", id: "scr_hf9e59" },
      { kind: "screen", id: "scr_n5uifq" },
      { kind: "screen", id: "scr_j0s6va" },
    ] },
    { kind: "section", id: "sec_wfdsi5", children: [
      { kind: "screen", id: "scr_vtw554" },
      { kind: "screen", id: "scr_52dh9g" },
      { kind: "screen", id: "scr_u82t8o" },
      { kind: "screen", id: "scr_w84ht7" },
      { kind: "screen", id: "scr_afn9mq" },
      { kind: "screen", id: "scr_2nbi2f" },
      { kind: "screen", id: "scr_9ag3z6" },
      { kind: "screen", id: "scr_hd3w67" },
    ] },
    { kind: "section", id: "sec_h3nwe0", children: [
      { kind: "screen", id: "scr_gyrws6" },
      { kind: "screen", id: "scr_uo95yt" },
    ] },
    { kind: "section", id: "sec_oo5hxd", children: [
      { kind: "screen", id: "scr_qqjo3p" },
    ] },
  ],
}
